const LA = 'America/Los_Angeles';
function parts(iso) {
    const t = Date.parse(iso);
    if (Number.isNaN(t))
        return null;
    const out = {};
    for (const p of new Intl.DateTimeFormat('ru-RU', {
        timeZone: LA,
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date(t))) {
        out[p.type] = p.value;
    }
    return out;
}
/** «04.11». */
export function laDayMonth(iso) {
    const p = parts(iso);
    return p ? `${p['day']}.${p['month']}` : '—';
}
/** «04.11 19:05». */
export function laStamp(iso) {
    const p = parts(iso);
    return p ? `${p['day']}.${p['month']} ${p['hour']}:${p['minute']}` : '—';
}
/** Строка делённой кампании: есть номер версии (только при `split=revision`). */
export const isSegment = (c) => typeof c.revision === 'number';
/** «Название · версия 2». */
export const segmentTitle = (title, revision) => `${title} · версия ${revision}`;
/** «версия 2 · с 04.11 19:05 до 05.11 14:10» / «версия 3 · с 04.11 19:05». */
export function revisionLine(c) {
    if (typeof c.revision !== 'number')
        return null;
    const w = c.revisionWindow;
    if (!w)
        return `версия ${c.revision}`;
    return `версия ${c.revision} · с ${laStamp(w.from)}${w.to ? ` до ${laStamp(w.to)}` : ''}`;
}
/** Пометки дня правки внутри строки: «смешанный день 04.11» (расход дня разделён по часам). */
export function mixedDaysLabel(days) {
    if (!days || days.length === 0)
        return null;
    const f = (d) => `${d.slice(8, 10)}.${d.slice(5, 7)}`;
    return `смешанный день ${days.map(f).join(', ')}`;
}
/** Метки правок по кампаниям (поле `meta.settingsChanges`; нет поля — пусто). */
export function changesByCampaign(report) {
    const out = new Map();
    for (const ch of report?.meta.settingsChanges ?? []) {
        const list = out.get(ch.campaignId);
        if (list)
            list.push(ch);
        else
            out.set(ch.campaignId, [ch]);
    }
    for (const list of out.values())
        list.sort((a, b) => Date.parse(a.effectiveFrom) - Date.parse(b.effectiveFrom));
    return out;
}
/** Разделение по версиям доступно: auto-ads прислал `settingsChanges` (флаг включён). */
export const splitAvailable = (report) => report !== undefined && (report.meta.settingsChanges ?? null) !== null;
const FUNNELS = {
    2: 'две воронки',
    3: 'три воронки',
    4: 'четыре воронки',
    5: 'пять воронок',
};
/** «Настройки воронки изменены 04.11 в 19:05 (версия 2). Цифры за период смешивают две воронки.» */
export function changeTooltip(changes) {
    const when = changes
        .map((c) => {
        const s = laStamp(c.effectiveFrom);
        return `${s.slice(0, 5)} в ${s.slice(6)} (версия ${c.revision})`;
    })
        .join(' и ');
    const n = changes.length + 1;
    return `Настройки воронки изменены ${when}. Цифры за период смешивают ${FUNNELS[n] ?? `${n} воронок`}.`;
}
/** Подпись метки на графике: «Настройки изменены 04.11 · версия 2». */
export const changeMarkLabel = (c) => `Настройки изменены ${laDayMonth(c.effectiveFrom)} · версия ${c.revision}`;
//# sourceMappingURL=revision-labels.js.map